var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { toPascalCase } from "./utils.js";
class BlockRegistryTarget {
    constructor() {
        this.listeners = new Set();
        this.registrationListeners = new Set();
        this.loadedListeners = new Set();
    }
    addEventListener(type, listener) {
        if (type === "loaded") {
            this.loadedListeners.add(listener);
        }
        if (type === "registration") {
            this.registrationListeners.add(listener);
        }
    }
    removeEventListener(type, listener) {
        if (type === "loaded") {
            this.loadedListeners.delete(listener);
        }
        if (type === "registration") {
            this.registrationListeners.delete(listener);
        }
    }
    registerNewBlock(blockName, blockLoader) {
        this.registrationListeners.forEach((listener) => {
            listener({ detail: { name: blockName, loader: blockLoader } });
        });
    }
    loadedNewBlock(block) {
        this.loadedListeners.forEach((listener) => {
            listener({ detail: { block: block } });
        });
    }
}
const blockRegistryEventTarget = new BlockRegistryTarget();
export const addBlockRegistryListener = blockRegistryEventTarget.addEventListener.bind(blockRegistryEventTarget);
export const removeBlockRegistryListener = blockRegistryEventTarget.removeEventListener.bind(blockRegistryEventTarget);
export const blockRegistry = new Proxy({}, {
    get(target, p) {
        return target[p];
    },
    set(target, p, value) {
        if (typeof p === "symbol") {
            return false;
        }
        let promise = undefined;
        const r = () => {
            return promise !== null && promise !== void 0 ? promise : (promise = value());
        };
        target[p] = () => new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const block = yield r();
                blockRegistryEventTarget.loadedNewBlock(block);
                resolve(block);
            }
            catch (e) {
                reject(e);
            }
        }));
        target[toPascalCase(p)] = target[p];
        blockRegistryEventTarget.registerNewBlock(p, target[p]);
        return true;
    },
});
export function hasBlock(name) {
    var _a;
    return (((_a = blockRegistry[name]) !== null && _a !== void 0 ? _a : blockRegistry[toPascalCase(name)]) !== undefined);
}
export function getBlock(name) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        let blockLoader = (_a = blockRegistry[name]) !== null && _a !== void 0 ? _a : blockRegistry[toPascalCase(name)];
        if (blockLoader === undefined) {
            throw new Error(`Block ${name} does not exists`);
        }
        return yield blockLoader();
    });
}
/**
 * Register a Block type as a Gutenberg component.
 * This force registration of any block as a Smartfire block available in the page.
 * This function is handled by the compilation magic, but you can use yourself to directly register blocks.
 *
 * @param name the component identifier
 * @param component
 * @param vendor
 */
export default function registerBlock(name, component) {
    // noinspection SuspiciousTypeOfGuard because of JS, we must ensure that
    if (typeof name !== "string") {
        throw new Error("First parameter MUST be the component name");
    }
    blockRegistry[name] = () => __awaiter(this, void 0, void 0, function* () {
        try {
            const blockModule = yield component();
            let block;
            if (blockModule && blockModule.hasOwnProperty("default")) {
                block = blockModule
                    .default;
            }
            else {
                block = blockModule;
            }
            Object.defineProperty(block, "name", { value: toPascalCase(name) });
            if (block._smartfire === undefined) {
                console.warn(`Your block ${name} does not seems to be a Smartfire block, are you sure to have used the \`defineBlock\` wrapper?\nWe have skipped Gutenberg registration.`);
            }
            return block;
        }
        catch (e) {
            console.error("Failed to load the block due to a fatal error for block " + name);
            console.error(e);
            throw e;
        }
    });
    return blockRegistry[name];
}

//# sourceMappingURL=registerBlock.js.map
